import styled from "styled-components";

export const OptionList = styled.div`
  box-sizing: border-box;
  position: absolute;
  top: ${props => props.theme.name !== 'gogurt' ? '50px' : '70px'};
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  margin: 0;
  padding: 10px;
  z-index: 3;
  background: white;
  border: 1px solid #e5e5e5;
  border-radius: 4px;

  li {
    list-style: none;
    cursor: pointer;
    margin: 0;
    padding: 4px;
    border-radius: 4px;

    &.active {
      background: #f2f2f2;
    }

    &:hover {
      background: #f2f2f2;
    }
  }
`;
